// extracted by mini-css-extract-plugin
module.exports = {"customBackground":"TrackingCheckoutDetailsComponent-module__customBackground","blueBackground":"TrackingCheckoutDetailsComponent-module__blueBackground"};